import { useState } from 'react';
import api from '../utils/api';
import { getStoredReferral } from '../utils/referral';
import './NewsletterSignup.css';

export default function NewsletterSignup({ source = 'footer' }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    const trimmed = email.trim();
    if (!trimmed) {
      setMessage('Enter your email.');
      return;
    }
    setStatus('loading');
    try {
      await api.post('/newsletter/subscribe', {
        email: trimmed,
        source,
        referralTag: getStoredReferral() || undefined,
      });
      setStatus('done');
      setMessage("You're on the list. We'll only email product updates and guides.");
      setEmail('');
    } catch (err) {
      setStatus('idle');
      const msg =
        err.response?.data?.error ||
        (err.response?.status === 503 ? 'Service busy — try again shortly.' : 'Something went wrong.');
      setMessage(msg);
    }
  };

  return (
    <section className="newsletter-signup" aria-labelledby="newsletter-heading">
      <h2 id="newsletter-heading" className="newsletter-signup-title">
        Email updates
      </h2>
      <p className="newsletter-signup-desc">
        Occasional notes on new games, features, and blog posts. No spam — unsubscribe any time.
      </p>
      {status === 'done' ? (
        <p className="newsletter-signup-success" role="status">
          {message}
        </p>
      ) : (
        <form className="newsletter-signup-form" onSubmit={onSubmit}>
          <label htmlFor="newsletter-email" className="visually-hidden">
            Email address
          </label>
          <input
            id="newsletter-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="you@example.com"
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
            disabled={status === 'loading'}
            className="newsletter-signup-input"
          />
          <button type="submit" disabled={status === 'loading'} className="newsletter-signup-btn">
            {status === 'loading' ? '…' : 'Subscribe'}
          </button>
        </form>
      )}
      {status !== 'done' && message ? <p className="newsletter-signup-error">{message}</p> : null}
    </section>
  );
}
